<template>
  <kst-page-export-details
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :access="access"
      :userData="userData"
      @init="handleExport_Init"
    />

    <kst-check disabled
      v-model="userData.WithDetails"
      :label="Info.Export.Details.Excel.Option.Details"
    />
    <template v-if="access.Receive_Act_List">
      <kst-check
        v-model="userData.WithReceiveList"
        :label="Info.Export.Details.Excel.Option.ReceiveList"
      />
    </template>
  </kst-page-export-details>
</template>

<script>
import Info from "../PurInfo.js";
import Model from "../PurModel.js";
import Services from "../../../services/Api/PurchaseServices.js";

import Export from "./PurExD_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    Info: Info,
    access: {},
    userData: {
      ID: null,
      WithDetails: true,
      WithReceiveList: true
    },
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit(id) {
      this.userData.ID = id;

      this.access = this.$kst.Access.create(Model.Access);
      this.userData.WithReceiveList = this.access.Receive_Act_List;
    },

    handleExport(loadExport) {
      const options = {
        withreceivelist: this.$kst.Out.getBoolean(
          this.userData.WithReceiveList),
      };

      const config = Services.getExportDetails(this.userData.ID, options);
      loadExport(config, this.handleExport_Success);
    },
    handleExport_Success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** custom ***/

    handleExport_Init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    }
  }
}
</script>